import { render, staticRenderFns } from "./admin-account-setup-layout.component.vue?vue&type=template&id=f7783650"
import script from "./admin-account-setup-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-account-setup-layout.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7783650')) {
      api.createRecord('f7783650', component.options)
    } else {
      api.reload('f7783650', component.options)
    }
    module.hot.accept("./admin-account-setup-layout.component.vue?vue&type=template&id=f7783650", function () {
      api.rerender('f7783650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/admin-account-setup-layout/admin-account-setup-layout.component.vue"
export default component.exports